import React from 'react'
import Coin from './../Public/Image/Join/Coin.svg'
import CoinBig from './../Public/Image/Home/Coin.svg'

import { useEffect } from 'react'
import './CoinHeader.css'
import { useSelector, useDispatch } from 'react-redux'
// import { GetProfile } from './../Api/GetProfile'
import { AllApi } from './../Api/AllApi'

import { GetCookie } from '../Action/GetCookie'
import { setUserCoin } from './../app/Home'
import { SetEmail } from './../app/Slice'
import { db } from './../DataBase/db'
import { useHistory } from 'react-router-dom';
import { TelegramDB } from './../DataBase/TelegramDB'
import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import { Link } from 'react-router-dom';
import { SetActiveTab } from './../app/JoinState'
import { setLoading } from './../app/Home'
import xpplus from './../Public/Image/Join/xpplus.svg'
import { useState } from 'react'
import HeadImg from './../../src/Public/Image/Game/Group 26086606.svg'
import { BottomSheet } from 'react-spring-bottom-sheet'
import { GameDB } from '../DataBase/GameDB'
import Snackbar from '@mui/material/Snackbar';
import Star from './../Public/Image/Game/Star.svg'
import StarFull from './../Public/Image/Join/Star 8 (1).svg'
import BronzeImg from './../Public/Image/Game/bronze.svg'
import SilverImg from './../Public/Image/Game/Silver.svg'
import GoldImg from './../Public/Image/Game/Gold.svg'
import PlatinumImg from './../Public/Image/Game/Platinum.svg'
import DiamondImg from './../Public/Image/Game/Diamond.svg'
import EpicImg from './../Public/Image/Game/Epic.svg'
import LegendryImg from './../Public/Image/Game/Legendry.svg'
import MasterImg from './../Public/Image/Game/Master.svg'
import GrandMasterImg from './../Public/Image/Game/GrandMaster.svg'
import LordImg from './../Public/Image/Game/Lord.svg'
import CreatorImg from './../Public/Image/Game/Creator.svg'
const CoinHeader = () => {
    const dispatch = useDispatch()
    const CountJoining = useSelector((state) => state.JoinState.CountJoining)
    const history = useHistory();

    const UserCoin = useSelector((state) => state.Home.UserCoin)
    const Token = GetCookie('Token');
    const [PointDialogState, setPointDialogState] = useState('')
    const [xpCount, setxpCount] = useState('')
    const [xpLevel, setxpLevel] = useState('')
    const [xpLimit, setxpLimit] = useState('')
    const xpCountLeague = useSelector((state) => state.Game.xpCountLeague)
    const MyLeagueRankNumber = useSelector((state) => state.Game.MyLeagueRankNumber)
    const MyLeagueRank = useSelector((state) => state.Game.MyLeagueRank)
    const XpMax = useSelector((state) => state.Game.XpMax)
    const [LoadState, setLoadState] = useState(false)
    const GetProfileFunction = async () => {
        const MakeApiClass = new AllApi();

        let TelegramAccountUpdatelimit = await TelegramDB.Data.toArray()

        if (TelegramAccountUpdatelimit.length > 0) {
            let arr = []
            TelegramAccountUpdatelimit.map(item => {
                arr.push(item.BotSession)
            })

            let restransfer = await MakeApiClass.accountTransfer(arr)

            arr = []
        } else {
            let arr = []


            let restransfer = await MakeApiClass.accountTransfer(arr)

        }






        let AppSetting = await GameDB.AppSetting.toArray()
        // console.log(AppSetting)
        if (AppSetting.length > 0) {
            setPointDialogState(AppSetting[0].AppSetting.PointDialog)
        }


        let res = await MakeApiClass.GetProfile(Token)
        // let res = await GetProfile(Token)


        if (res.code == 200) {

            setxpCount(res.data.user.xpCount)
            setxpLevel(res.data.user.xpLevel)
            setxpLimit(res.data.user.xpLimit)
            dispatch(setUserCoin(res.data.user.coins))
            let res1 = db.Data.where({ id: Number(1) }).modify({ Email: res.data.user.email })
            dispatch(SetEmail(res.data.user.email))

        } else if (res.code == 120 || res.code == 121 || res.code == 122 || res.code == 123) {
            let name = "Token"
            let name1 = "active"
            document.cookie = name + '=; Max-Age=-99999999;';
            document.cookie = name1 + '=; Max-Age=-99999999;';
            // console.log(234)

            history.push("/");
            // dispatch(setLoading(false))

        } else if (res.code == 999) {

            handleClick({ vertical: 'bottom', horizontal: 'center' })

        }

    }
    const [state, setState] = React.useState({
        opens: false,
        vertical: 'top',
        horizontal: 'center',
    });
    const { vertical, horizontal, opens } = state;
    const handleClick = (newState) => {
        setState({ ...newState, opens: true });
    };
    const handleClose = () => {
        setState({ ...state, opens: false });
    };

    useEffect(() => {
        GetProfileFunction()
    }, [UserCoin])
    const urlParams = new URLSearchParams(window.location.search);


    // const Tab = useSelector((state) => state.JoinState.Tab)
    // const ActiveTab = useSelector((state) => state.JoinState.ActiveTab)
    const SetTabsStatusJoin = (index) => {
        dispatch(setLoading(true))
        localStorage.setItem("CoinFilter", index)
        dispatch(SetActiveTab(index))
        let name
        if (index == 0) {
            name = "Join"
        } else if (index == 1) {
            name = 'Buy'
        } else if (index == 2) {
            name = 'Sale'
        } else if (index == 3) {
            name = "Transfer"
        } else if (index == 4) {
            name = "Gift"
        }

        urlParams.set('Status', index);
        let newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + urlParams.toString();
        window.history.pushState({ path: newurl }, '', newurl);
        setTimeout(() => {
            dispatch(setLoading(false))
        }, 100000);

    }




    const OpenBottomSheetShowXpDetails = () => {
        setBottomSheetState(true)
    }
    const [BottomSheetState, setBottomSheetState] = useState(false)
    function onDismiss() {
        setTimeout(() => {
            setBottomSheetState(false)
        }, 300);

    }

    function abbreviate_number(num) {
        if (num === null || num === undefined || num === false) return null;
        if (num === 0) return '0';

        let k = Math.floor((Math.log10(num)) / 3); // تعیین مقیاس (K, M, B, T)
        let scale = Math.pow(10, k * 3); // مقدار مقیاس برای تقسیم عدد
        let shortened = num / scale; // عدد را مقیاس‌بندی می‌کنیم

        return shortened.toFixed(1).replace(/\.0$/, '') + ['', 'K', 'M', 'B', 'T'][k]; // حذف `.0` از اعداد صحیح
    }

    const [League, setLeague] = useState('')
    const [Rank, setRank] = useState('')
    const [ForStyle, setForStyle] = useState('')
    const [IsCreator1, setIsCreator1] = useState(false)

    const Style = {
        Bronze: {
            img: BronzeImg,
            imgBg: '#BF897066',
            Rank: '#BF897033',
            Rank2: '#321203',
            Rank3:"#FFEDE6",
            Progress: '#BF8970',
            ListBorder: '#BF8970',
            ListTitleBg: '#BF8970',
            ListTitleText: '#321203',
            ListTitleYou: '#4B2714',
            ListTitleYouBg: '#FFEDE6',
            ListBodyBg: '#FFEDE6',
            ListBodyText: '#321203'
        },
        Silver: {
            img: SilverImg,
            imgBg: '#8E9FAF66',
            Rank: '#8E9FAF33',
            Rank2:"#22323F",
            Rank3:"#FFFFFF",
            Progress: '#8E9FAF',
            ListBorder: '#8E9FAF',
            ListTitleBg: '#8E9FAF',
            ListTitleText: '#22323F',
            ListTitleYou: '#22323F',
            ListTitleYouBg: '#F3F3F3',
            ListBodyBg: '#F3F3F3',
            ListBodyText: '#22323F'
        },
        Gold: {
            img: GoldImg,
            imgBg: '#FFD10066',
            Rank: '#FFD41233',
            Rank2: '#8F4F2C',
            Rank3: '#FFFFFF',
            Progress: '#FFD100',
            ListBorder: '#FFD100',
            ListTitleBg: '#FFD100',
            ListTitleText: '#3C2F00',
            ListTitleYou: '#3C2F00',
            ListTitleYouBg: '#FFF0C9',
            ListBodyBg: '#FFF0C9',
            ListBodyText: '#3C2F00'
        },
        Platinum: {
            img: PlatinumImg,
            imgBg: '#ACB2AC66',
            Rank: '#B1B8B133',
            Rank2: '#373D37',
            Rank3: '#FFFFFF',
            Progress: '#ACB2AC',
            ListBorder: '#ACB2AC',
            ListTitleBg: '#ACB2AC',
            ListTitleText: '#2C322E',
            ListTitleYou: '#2C322E',
            ListTitleYouBg: '#DEE4DD',
            ListBodyBg: '#2C322E',
            ListBodyText: '#424844'
        },
        Diamond: {
            img: DiamondImg,
            imgBg: '#B3ECF966',
            Rank: '#B3ECF933',
            Rank2: '#00363E',
            Rank3: '#FFFFFF',
            Progress: '#B9F2FF',
            ListBorder: '#B9F2FF',
            ListTitleBg: '#B9F2FF',
            ListTitleText: '#00363E',
            ListTitleYou: '#2C322E',
            ListTitleYouBg: '#EDFCFF',
            ListBodyBg: '#00363E',
            ListBodyText: '#0B4E59'
        },
        Epic: {
            img: EpicImg,
            imgBg: '#8C49CA66',
            Rank: '#8C49CA33',
            Rank2: '#2C0050',
            Rank3: '#FFFFFF',
            Progress: '#8C49CA',
            ListBorder: '#8C49CA',
            ListTitleBg: '#8C49CA',
            ListTitleText: '#FAECFF',
            ListTitleYou: '#4A007F',
            ListTitleYouBg: '#FAECFF',
            ListBodyBg: '#2C0050',
            ListBodyText: '#4A007F'
        },
        Legendary: {
            img: LegendryImg,
            imgBg: '#C0002166',
            Rank: '#C0002133',
            Rank2: '#410005',
            Rank3: '#FFFFFF',
            Progress: '#C00021',
            ListBorder: '#C00021',
            ListTitleBg: '#C00021',
            ListTitleText: '#FFEDEB',
            ListTitleYou: '#68000D',
            ListTitleYouBg: '#FFEDEB',
            ListBodyBg: '#410005',
            ListBodyText: '#68000D'
        },
        Master: {
            img: MasterImg,
            imgBg: '#5656FF66',
            Rank: '#5656FF33',
            Rank2: '#00006E',
            Rank3: '#FFFFFF',
            Progress: '#5656FF',
            ListBorder: '#5656FF',
            ListTitleBg: '#5656FF',
            ListTitleText: '#FFFBFF',
            ListTitleYou: '#1300A9',
            ListTitleYouBg: '#F2EFFF',
            ListBodyBg: '#08006C',
            ListBodyText: '#00006E'
        },
        Grandmaster: {
            img: GrandMasterImg,
            imgBg: '#0202A966',
            Rank: '#1212A333',
            Rank2: '#00006E',
            Rank3: '#FFFFFF',
            Progress: '#0202D3',
            ListBorder: '#0202D3',
            ListTitleBg: '#0202D3',
            ListTitleText: '#E0E0FF',
            ListTitleYou: '#0202A9',
            ListTitleYouBg: '#E0E0FF',
            ListBodyBg: '#00006E',
            ListBodyText: '#0202A9'
        },
        Lord: {
            img: LordImg,
            imgBg: '#006C4466',
            Rank: '#006C4433',
            Rank2: '#003921',
            Rank3: '#FFFFFF',
            Progress: '#006C44',
            ListBorder: '#006C44',
            ListTitleBg: '#006C44',
            ListTitleText: '#C0FFD7',
            ListTitleYou: '#005232',
            ListTitleYouBg: '#C0FFD7',
            ListBodyBg: '#003921',
            ListBodyText: '#005232'
        },
        Creator: {
            img: CreatorImg,
            imgBg: '#21212166',
            Rank: '#21212133',
            Rank2: '#212121',
            Rank3: '#FFFFFF',
            Progress: '#212121',
            ListBorder: '#212121',
            ListTitleBg: '#212121',
            ListTitleText: '#FFFFFF',
            ListTitleYou: '#212121',
            ListTitleYouBg: '#FFFFFF',
            ListBodyBg: '#212121',
            ListBodyText: '#212121'
        },
    }
   
    const [NextTargetLeague, setNextTargetLeague] = useState(false)
    useEffect(() => {
        const loadData = async () => {
            const AppSetting = await GameDB.AppSetting.toArray();

            const LeagesInAppSetting = AppSetting[0].AppSetting.leagues

            for (let index = 0; index < LeagesInAppSetting.length; index++) {
                const item = LeagesInAppSetting[index];
                if (item.leagueLevel == MyLeagueRankNumber) {
                    if (item.leagueLevel == 33) {
                        setNextTargetLeague(LeagesInAppSetting[index].leagueName)
                    }
                    setNextTargetLeague(LeagesInAppSetting[index + 1].leagueName)
                }

            }

            setLoadState(true);

            const leagues = [
                'Bronze', 'Silver', 'Gold', 'Platinum', 'Diamond',
                'Epic', 'Legendary', 'Master', 'Grandmaster', 'Lord', 'Creator'
            ];

            for (const leagueName of leagues) {
                if (MyLeagueRank.includes(leagueName)) {
                    setLeague(leagueName);
                  
                    setForStyle(Style[leagueName]);

                    const rank = MyLeagueRank.replace(leagueName, '').trim();
                    setRank(rank);

                    if (leagueName === 'Creator') {
                        setIsCreator1(rank === 'I');
                    } else {
                        setIsCreator1(false);
                    }

                    break;
                }
            }

            setTimeout(() => {
                setLoadState(false);
            }, 2000);
        };

        loadData();
    }, [MyLeagueRank]);
   
    return (

        <div className='CoinHeader'>
            <Link to="/Game"  className='HeaderLogo' style={{ backgroundColor: ForStyle.Rank }}
      // onClick={() => OpenBottomSheetShowXpDetails()}
      >

        <div className='HeaderLogoPt'>
          <div className='GameCupImgContainer'>
            <img src={ForStyle.img} style={{ background: ForStyle.imgBg, borderRadius: '33px', width: "35px", height: "35px", padding: "2px", marginTop: "3px" }} className='GameCupImg' />
            <div className='GameLeagueNameNew' style={{ backgroundColor: ForStyle.Rank2, color: ForStyle.Rank3 }} >{Rank} </div>
          </div>


          <span className='HeaderLogoPtInner' style={{ marginLeft: "8px", color: ForStyle.ListBodyText, height: "34px" }} >
            <span className='PtLogoAndHeaderLogoPtInner' >
              {abbreviate_number(XpMax - xpCountLeague)}
              <img src={StarFull} className='HeaderProgressBarImg' style={{ width: "10px", height: "10px" }} />
            </span>
            to
            {" " + NextTargetLeague}

          </span>

        </div>
      </Link>

            <div className='HeaderCoin' id='HeaderCoin' >
                {/* <AddCircleRoundedIcon className='AddCoinIcon' /> */}

                <div>
                    {UserCoin.toLocaleString()}
                </div>
                <div className='HeaderCoinImgContainer'>
                    {
                        CountJoining > 0 ?
                            <>
                                <div className='CoinHeaderImageLoader'></div>
                                <img src={Coin} className='HeaderCoinImg1' />
                            </>

                            :
                            <img src={Coin} className='HeaderCoinImg1' />

                    }

                </div>

            </div>

            <BottomSheet onDismiss={onDismiss} open={BottomSheetState}>
                <div className='RegisterBeforeBottomSheet'>
                    <div className='RegisterBeforeBottomSheetHeader'>
                        <div className='HeaderLogoBottomSheet' >
                            {xpCountLeague == 0 || xpCountLeague == 1 ?
                                "Point"
                                :
                                "Points"
                            }  in this event:
                            <b style={{ margin: "0 4px 0 4px" }}>
                                {xpCountLeague > 0 ? xpCountLeague.toLocaleString() : 0}
                            </b>
                            <img src={xpplus} className='XpCountInlistIcon' style={{ "width": "14px", "height": "14px" }} />

                        </div>

                    </div>
                    <div className='HeaderLogoBottomSheetText' >
                        How can we get Points?

                    </div>
                    <ul className='BottomSheetUlXpUl'>
                        {
                            PointDialogState ?
                                PointDialogState.map((item, i) =>
                                    <li key={i} style={{ "marginTop": "8px" }}>{item}</li>
                                )
                                : null
                        }

                    </ul>

                    <div className='RegisterBeforeBottomSheetFooter'>
                        <Link to="/Profile" className='BottomSheetCancelButton'  >Show All pts</Link>
                        <button className="BottomSheetLoginButton" onClick={() => setBottomSheetState(false)}>Got it</button>

                    </div>
                </div>
            </BottomSheet>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                open={opens}
                onClose={handleClose}
                message="Something went wrong"
                key={vertical + horizontal}
                autoHideDuration={3000}
            />
        </div>
    )
}

export default CoinHeader